import { useState,  useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff, FiInfo } from "react-icons/fi";
import { ToastContainer, toast } from "react-toastify";

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
   // Redirect to /admin if already logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("adminLogin") === "true";
    if (isLoggedIn) {
      navigate("/admin"); // Redirect to /admin
    }
  }, [navigate]);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

   
  try {
    const response = await fetch(`${process.env.REACT_APP_LOGIN_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: username,
        password: password,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      toast.success("Login successfully!");
      localStorage.setItem("adminToken", data.token); // Store the token

      localStorage.setItem("adminLogin", true); // Store the token

      navigate("/admin"); // Redirect to the admin panel

    } else {
      toast.error(`User name or passowrd is wrong`);
      setError(data.message || "Login failed. Please try again.");
    }
  } catch (err) {
    toast.error(`At this time login is not avaible. Please Try again.`);

    setError("An error occurred. Please try again.");
  }
  };

  return (

    <div
      className="flex items-center justify-center min-h-screen bg-gray-100 p-4"
      style={{
        backgroundImage: `url('./assets/images/jewelry_bg.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
    <ToastContainer position="top-center" autoClose={3000} />

      <div className="w-full max-w-md bg-white bg-opacity-90 rounded-lg shadow-lg p-8 m-4">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src="/assets/images/logos/Without_BG_BLACK.png"
            alt="Logo"
            className="w-16"
          />
        </div>

        {/* Welcome Text */}
        <h2 className="text-center text-2xl font-semibold text-gray-700 mb-8">
          Welcome to Wellstar Jewels
        </h2>

        <form onSubmit={handleLogin}>
          {/* Username Field */}
          <div className="mb-4">
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Username
            </label>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-gray-500"
            />
          </div>

          {/* Password Field */}
          <div className="mb-4 relative">
            <label className=" text-sm font-semibold text-gray-700 mb-1 flex items-center">
              Password
              <FiInfo className="ml-1 text-gray-400" />
            </label>
            <input
              type={passwordVisible ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-gray-500"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute right-2 top-10 text-gray-500"
            >
              {passwordVisible ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

          {/* Remember Me and Forgot Password */}
          

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
